// extracted by mini-css-extract-plugin
export default {"cardWrap":"TemplateCard_cardWrap__wDjJD"};